export default status => {
  if (status === 'LINKED') {
    return '#4C51C2';
  } if (status === 'UNLINKED') {
    return '#D17621';
  } return '#D17621';
};
